import { useEffect, useState } from 'react';

/**
 * useDebouncedValue — returns `value` after it has stopped changing for `delayMs`.
 *
 * Used by the server-side list pages (ParcelsList/ClientsList/PropertiesList) so
 * a fast typist doesn't fire a `q=` request per keystroke — the debounced value
 * feeds the react-query key, so only the settled search term hits the server.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
